<template>
    <div class="market-total-ball-container">
        <Title :title="title" />
        <div class="total-ball__content">
            <div class="total-ball__item" :class="{ 'selected': numbersSelected.some(x => x.id == c.id) }"
                v-for="(c, index) in outcomes" :key="index" @click="handleSelectball(c)">
                <Number :number="c.name" />
                <p>{{ formatPrice(c.odds) }}</p>
                <span class="icon-check" v-if="numbersSelected.some(x => x.id == c.id)">
                    <i class="bi bi-check"></i>
                </span>
            </div>
        </div>
        <div class="total-ball__action">
            <ButtonCommon text="add" class="button__primary" :isDisable="numbersSelected.length == 0"
                @action="addTotalBall" />
        </div>
    </div>
</template>
<script>
import Title from "@/components/common/title/index.vue";
import Number from "@/components/common/number";
import ButtonCommon from "@/components/common/button";
import EventBus from '@/utils/EventBus';
import utilsMixin from '@/mixins/function-utils'

export default {
    mixins: [utilsMixin],
    components: { Title, Number, ButtonCommon },
    props: {
        outcomes: {
            type: Array,
        },
        title: {
            type: String,
        }
    },
    data() {
        return {
            numbersSelected: [],
        }
    },
    methods: {
        handleSelectball(number) {
            const outcomeValue = 1; // only select 1 ball
            const ballValue = number.name;

            if (this.numbersSelected.some(selectedBall => selectedBall.value === ballValue)) {
                this.numbersSelected = this.numbersSelected.filter(selectedBall => selectedBall.name !== ballValue);
            } else if (this.numbersSelected.length < outcomeValue) {
                this.numbersSelected.push(number);
            } else {
                this.numbersSelected = []
                this.numbersSelected.push(number)
            }
        },

        addTotalBall() {
            this.$emit('addTotalBall', this.numbersSelected[0])
            this.numbersSelected = [];

            setTimeout(() => {
                EventBus.emit('calculate-bottom-page')
            })
        }

    }
}
</script>

<style lang="scss" scoped>
@import "@/public/scss/components/coupons/market-total-number.scss";
</style>
